export const queryExecApiUrlRegex = /api\/v1\/queries\/[^/]+\/exec(\?.*)?$/;

// This API header allows you to override whether empty strings should
// automatically get converted to NULL in the API.
// See: https://bitbucket.org/crose3333/channel-dynamics-api/src/e8e3ff2ebe9926e5000387d5efe2f24e3958cd0b/app/Http/Middleware/ConvertEmptyStringsToNull.php#lines-11
export const HEADER_CONVERT_EMPTY_STRINGS_TO_NULL =
  "Convert-Empty-Strings-To-Null";
export const HEADER_MERGE_JSON_DATA = "X-Merge-Json-Data";
export const HEADER_VISUALIZATION_UUID = "Visualization-Uuid";
export const HEADER_CONVERT_BOOLEANS = "Convert-Booleans";
